import { TargetAssociations } from '@/config/constants'

export const goals = state => state.goals
export const isLoading = state => state.isLoading
export const goalsHash = state => state.goalsHash
export const goalsWithCombinedMenuTypes = (state) => {
  const goals = state.goals || []
  const isEconomy = (goal) => goal.id === TargetAssociations.ECONOMY.ID

  // Собираем уникальные menuTypes, исключая эконом
  const combinedMenuTypes = goals.reduce((acc, goal) => {
    if (isEconomy(goal)) return acc

    goal.menuTypes.forEach((menuType) => {
      if (!acc.some(combinedMenuType => combinedMenuType.id === menuType.id)) {
        acc.push(menuType)
      }
    })

    return acc
  }, [])

  combinedMenuTypes.sort((a, b) => a.kcal - b.kcal)

  return goals.map(goal => ({
    ...goal,
    menuTypes: isEconomy(goal) ? goal.menuTypes : combinedMenuTypes,
  }))
}
